import createAsyncGetters from '../config/asyncGetters/createAsyncGetters';
import { getStateSummary, StateSummary } from './guest.getters';

export const guestAsyncGetters = createAsyncGetters({
  getStateSummary: async (playerId: string, api): Promise<StateSummary> => {
    const { state } = (await api.fetchStates([playerId]))[playerId] ?? {};
    if (!state) {
      throw new Error(`State not found for playerId: ${playerId}`);
    }

    return getStateSummary(state, 'guest', state.lastLoginAt ?? 0);
  },
});
